import { createSlice } from "@reduxjs/toolkit";

const initialMovementsSlice = { 
        inventorysummary: { 
                isLoading: false,
                report: []
        }, 
        tanks: [],
        saveAdjustmentStatus: {
                isSaving: false,
                success: false,
                error: '',
                monthyear: ''
        },
        adjustmentdetails: {
                isLoading: false,
                success: false,
                error: '',
                details: null
        }
};

export const InventorySummarySlice = createSlice({
        name: "inventorysummary",
        initialState: initialMovementsSlice,
        reducers: { 
                StartLoadingDetails: (state) => {
                        state.adjustmentdetails = {
                                isLoading: true,
                                success: false,
                                error: '',
                                details: null
                        }
                },
                SetAdjustmentDetails: (state, action) => {
                        state.adjustmentdetails = {
                                isLoading: false,
                                success: action.payload.success,
                                error: action.payload.error,
                                details: action.payload.details
                        }
                },
                StartLoadingInventorySummary: (state, action) => {
                        state.inventorysummary = {
                                isLoading: true,
                                report: []
                        }
                },
                SetInventorySummaryLoaded: (state, action) => {
                        state.inventorysummary = {
                                isLoading: false,
                                report: action.payload.report
                        }
                }, 
                SetTanksList: (state, action) => {
                        state.tanks = action.payload.tanks;
                },
                StartSavingAdjustment: (state, action) => {
                        state.saveAdjustmentStatus = {
                                isSaving: true,
                                success: false,
                                error: '',
                                monthyear: ''
                        }
                },
                SetSavingAdjustmentStatus: (state, action) => {
                        state.saveAdjustmentStatus = {
                                isSaving: false,
                                success: action.payload.success,
                                error: action.payload.error,
                                monthyear: action.payload.monthyear
                        }
                },
                ResetSavingAdjustmentStatus: (state, action) => {
                        state.saveAdjustmentStatus = initialMovementsSlice.saveAdjustmentStatus;
                },
        }
});